import React, { useState, useEffect } from 'react';
import Enumerable from 'linq';

//material mui components
import { 
    Autocomplete,
     Grid,
     IconButton, 
     Table, 
     TableBody, 
     TableContainer, 
     TableHead, 
     TextField, 
     Tooltip,
     Typography
 } from '@mui/material';

//icons
import StarBorderOutlinedIcon from '@mui/icons-material/StarBorderOutlined';
import StarIcon from '@mui/icons-material/Star';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';

//config
import { enlistaArrayCodigosMensajesIdiomas } from '../../../../Actions/Generales/IdiomasAction';
import { ObtenerTablaRegistros, CrearNuevoRegistro, ActualizarRegistro, EliminarRegistro, EstablecerFavorito } from '../../../../Actions/Clientes/ClientesContactosAction';

//config home
import { MOBILE } from '../../config';

//Utilidades
import { MostrarMensaje } from '../../../../Utilidades/ManejoMensajes';
import { ValidarPropiedad } from '../../../../Utilidades/ValidarPropiedades';
import { useGlobalState } from '../../../../Utilidades/useGlobalState';

import { ActionTitleAndButtons } from '../ActionTitleAndButtons';

//styles
import { styleTable, StyleHome } from '../../../Tool/Style';

//styled components
import { StyledTableCellClass, StyledTableRowClass, StyledTableRowHeaderClass } from '../../../../theme/themeTableRow';

/**
 *
 * @param {{ deviceIs: "DESKTOP" | "MOBILE" | "TABLET" }} param0
 * @returns
 */
function TelefonosClientes({ deviceIs = "DESKTOP", DatosContactoInfo }) {

    const { CodigoVerificado, ListCamposRequeridos, Credenciales, TipoTelefono, ListTiposTelefonos, ElimenarRegistro } = DatosContactoInfo;

    const [registro, setRegistro] = useState({ id: '00000000-0000-0000-0000-000000000000', text: '' });

    const { etiquetas, codigoIdioma, dispatch} = useGlobalState();

    const [Contacto, setContacto] = useState({
        CustomerContactId: '00000000-0000-0000-0000-000000000000',
        CustomerId: Credenciales.customerId,
        ContactTypeId: ListTiposTelefonos.length > 0 ? ListTiposTelefonos[0].id : '00000000-0000-0000-0000-000000000000',
        CountryCode: '',
        Phone: '',
        Observation: '',
        CompanyId: Credenciales.companyId,
        UserId: Credenciales.userId
    });

    //test [{ cucCountryCode:"112313", cucPhone:"3053228640", cucCustomerContactId:1, cotDsc:"una de text" }]
    const [listContacts, setListContacts] = useState([]); // se encarga del recolectar el listado de contactos

    useEffect(() => {
       LoadContactosTable();
    }, [codigoIdioma]);

    useEffect(() => {
        if (registro.id !== '00000000-0000-0000-0000-000000000000') {
            ElimenarRegistro(registro.text, eliminaContact);
        }
    }, [registro]);

    const LoadContactosTable = async () => {
        
        const objReq = {
            CustomerId: Credenciales.customerId,
            UserId: Credenciales.userId
        };

        const response = await ObtenerTablaRegistros(objReq);
        if (response.status === 200) //si la respuesta fue existosa
        {
            setListContacts(response.data);
        }
        else {
            if (response.data.errors) {
                const arrayErrores = enlistaArrayCodigosMensajesIdiomas(response.data.errors);
                MostrarMensaje(dispatch, response.data.typeError, arrayErrores);
            } else {
                MostrarMensaje(dispatch, 'error', [response.statusText]);
            }
            setListContacts([]);
        }
    };

    const ingresarValoresMemoria = e => {
        const { name, value } = e.target;  // se desestructura del targen el nombre y el valor que trae

        // se usa el hook de useState sobre la variable de estado local y se actualiza solo la propiedad que concuerda con el
        // valor que se le envia lo demas se queda igual 
        setContacto((anterior) => ({
            ...anterior,
            [name]: value
        }));
    };

    function salvarTelefono() {
        const objetoContacto = {
            CustomerContactId: Contacto.CustomerContactId,
            CustomerId: Contacto.CustomerId,
            ContactTypeId: Contacto.ContactTypeId,
            CountryCode: Contacto.CountryCode,
            Phone: Contacto.Phone,
            Observation: Contacto.Observation,
            CompanyId: Credenciales.companyId,
            UserId: Credenciales.userId
        };

        const validacionCampos = ValidarPropiedad(ListCamposRequeridos, objetoContacto, dispatch);

        if (validacionCampos) {

            dispatch({ type: "LOAD_CLIENT", texto: etiquetas.CargandoModal.Et_Procesando });
            if (Contacto.CustomerContactId !== '00000000-0000-0000-0000-000000000000') {
                ActualizarRegistro(objetoContacto).then(response => {
                    if (response.status === 200) //si la respuesta fue existosa 
                    {
                        LoadContactosTable();
                        NuevoContacto();
                        MostrarMensaje(dispatch, 'success', ["updateOk"]);
                    }
                    else {
                        if (response.data.errors) {
                            const arrayErrores = enlistaArrayCodigosMensajesIdiomas(response.data.errors);
                            MostrarMensaje(dispatch, response.data.typeError, arrayErrores);
                        } else {
                            MostrarMensaje(dispatch, 'error', [response.statusText]);
                        }
                    }
                });
                dispatch({ type: "CLOSE_LOAD_CLIENT" });
            }
            else {
                CrearNuevoRegistro(objetoContacto).then(response => {
                    if (response.status === 200) //si la respuesta fue existosa 
                    {
                        LoadContactosTable();
                        NuevoContacto();
                        MostrarMensaje(dispatch, 'success', ["insertOk"]);
                    }
                    else {
                        if (response.data.errors) {
                            const arrayErrores = enlistaArrayCodigosMensajesIdiomas(response.data.errors);
                            MostrarMensaje(dispatch, response.data.typeError, arrayErrores);
                        } else {
                            MostrarMensaje(dispatch, 'error', [response.statusText]);
                        }
                    }
                });
                dispatch({ type: "CLOSE_LOAD_CLIENT" });
            }
        }
    };

    function NuevoContacto() {
        setContacto({
            CustomerContactId: '00000000-0000-0000-0000-000000000000',
            CustomerId: Credenciales.customerId,
            ContactTypeId: ListTiposTelefonos.length > 0 ? ListTiposTelefonos[0].id : '00000000-0000-0000-0000-000000000000',
            CountryCode: '',
            Phone: '',
            Observation: '',
            CompanyId: Credenciales.companyId,
            UserId: Credenciales.userId
        });
        TipoTelefono.SetInfo(ListTiposTelefonos.length > 0 ? { id: ListTiposTelefonos[0].id, description: ListTiposTelefonos[0].description } : { id: '00000000-0000-0000-0000-000000000000', description: '' });
    };

    function EditarContactoFavorito(telefono) {

        const objetoFavorito = {
            CustomerContactId: telefono.cucCustomerContactId,
            CustomerId: Credenciales.customerId,
            CompanyId: Credenciales.companyId,
            UserId: Credenciales.userId
        };

        EstablecerFavorito(objetoFavorito).then(response => {
            if (response.status === 200) //si la respuesta fue existosa 
            {
                LoadContactosTable();
                NuevoContacto();
            }
            else {
                if (response.data.errors) {
                    const arrayErrores = enlistaArrayCodigosMensajesIdiomas(response.data.errors);
                    MostrarMensaje(dispatch, response.data.typeError, arrayErrores);
                } else {
                    MostrarMensaje(dispatch, 'error', [response.statusText]);
                }
            }
        });
    };

    function EditarContacto(contacto) {
        setContacto({
            CustomerContactId: contacto.cucCustomerContactId,
            CustomerId: Credenciales.customerId,
            ContactTypeId: contacto.cucContactTypeIdFk,
            CountryCode: contacto.cucCountryCode,
            Phone: contacto.cucPhone,
            Observation: contacto.cucObservation,
            CompanyId: Credenciales.companyId,
            UserId: Credenciales.userId
        });
        const tipoTemp = Enumerable.from(ListTiposTelefonos).firstOrDefault(x => x.id === contacto.cucContactTypeIdFk);
        TipoTelefono.SetInfo(ListTiposTelefonos.length > 0 && tipoTemp !== undefined ? tipoTemp : { id: '00000000-0000-0000-0000-000000000000', description: '' });
    };

    const eliminaContact = async () => {
        const objetoEliminar = {
            CustomerContactId: registro.id,
            CompanyId: Credenciales.companyId,
            UserId: Credenciales.userId
        };

        EliminarRegistro(objetoEliminar).then(response => {
            if (response.status === 200) //si la respuesta fue existosa 
            {
                MostrarMensaje(dispatch, 'success', ["deleteOk"]);
                NuevoContacto();
                LoadContactosTable();
            }
            else {
                if (response.data.errors) {
                    const arrayErrores = enlistaArrayCodigosMensajesIdiomas(response.data.errors);
                    MostrarMensaje(dispatch, response.data.typeError, arrayErrores);
                } else {
                    MostrarMensaje(dispatch, 'error', [response.statusText]);
                }
            }
            ElimenarRegistro('', null);
        });
    };

    function ManejadorTipoTelefono(id) {
        setContacto((anterior) => ({
            ...anterior,
            ContactTypeId: id
        }));
    };

    const ingresarValoresMemoriaAuto = (event, newValue) => {
        if (newValue === null || newValue === undefined || newValue === '') {
            TipoTelefono.SetInfo({ id: '00000000-0000-0000-0000-000000000000', description: '' });
            ManejadorTipoTelefono('00000000-0000-0000-0000-000000000000');
        } else {
            TipoTelefono.SetInfo(newValue);
            ManejadorTipoTelefono(newValue.id);
        }
    };

    return (
        <React.Fragment>

           <ActionTitleAndButtons  
             deviceIs={deviceIs}
             titleOption={etiquetas.InterfazClienteContactInfo.Et_tblPhone}
             cleanClick={NuevoContacto}
             saveClick={salvarTelefono}
             CodigoVerificado={CodigoVerificado} />

            <div>
                <Grid key='GridContactInformation' container style={StyleHome.GridConteiner} >
                    <Grid item xs={deviceIs === MOBILE ? 12 : 4} sm={4} md={4} style={StyleHome.GridItem}>
                        <Autocomplete
                            disabled={CodigoVerificado === false}
                            noOptionsText={etiquetas.General.Et_tblSinOpciones}
                            fullWidth
                            value={TipoTelefono.Info}
                            name='TipoTelefono'
                            options={ListTiposTelefonos}
                            onChange={ingresarValoresMemoriaAuto}
                            getOptionLabel={(option) => option.description}
                            renderInput={(params) => <TextField name='label' {...params} label=
                                {Enumerable.from(ListCamposRequeridos).any(x => x.code === 'ContactTypeId') ?
                                    etiquetas.InterfazClienteContactInfo.Et_tblPhoneType + ' *' :
                                    etiquetas.InterfazClienteContactInfo.Et_tblPhoneType
                                } />}
                        />
                    </Grid>
                    <Grid item xs={deviceIs === MOBILE ? 12 :  4} sm={4} md={4} style={StyleHome.GridItem}>
                        <TextField
                            disabled={CodigoVerificado === false}
                            name="CountryCode"
                            value={Contacto.CountryCode}
                            variant="outlined"
                            fullWidth
                            label={Enumerable.from(ListCamposRequeridos).any(x => x.code === 'CountryCode') ?
                                etiquetas.InterfazClienteContactInfo.Et_tblCountryCode + ' *' :
                                etiquetas.InterfazClienteContactInfo.Et_tblCountryCode
                            }
                            onChange={ingresarValoresMemoria}
                            inputProps={{
                                maxLength: 5
                            }}>
                        </TextField>
                    </Grid>
                    <Grid item xs={deviceIs === MOBILE ? 12 : 4} sm={4} md={4} style={StyleHome.GridItem}>
                        <TextField
                            disabled={CodigoVerificado === false}
                            name="Phone"
                            value={Contacto.Phone}
                            variant="outlined"
                            fullWidth
                            label={Enumerable.from(ListCamposRequeridos).any(x => x.code === 'CountryCode') ?
                                etiquetas.InterfazClienteContactInfo.Et_tblPhone + ' *' :
                                etiquetas.InterfazClienteContactInfo.Et_tblPhone
                            }
                            onChange={ingresarValoresMemoria}
                            inputProps={{
                                maxLength: 20
                            }}>
                        </TextField>
                    </Grid>
                    <Grid item xs={12} sm={12} md={12} style={StyleHome.GridItem}>
                        <TextField
                            disabled={CodigoVerificado === false}
                            multiline
                            name="Observation"
                            value={Contacto.Observation}
                            variant="outlined"
                            fullWidth
                            rows={2}
                            label={Enumerable.from(ListCamposRequeridos).any(x => x.code === 'CountryCode') ?
                                etiquetas.General.Et_tblObservation + ' *' :
                                etiquetas.General.Et_tblObservation
                            }
                            onChange={ingresarValoresMemoria}
                            inputProps={{
                                maxLength: 200
                            }}>
                        </TextField>
                    </Grid>
                    <Grid item xs={12} sm={12} md={12} style={StyleHome.GridItem}>
                        
                    { deviceIs === MOBILE ?
                     
                        <div  style={{display:'flex', flexDirection:'column'}}>
                          {listContacts.length > 0 ? listContacts.map((registro) => (
                              <div key={registro.cucCustomerContactId + 'mobile'}>
                              <div  style={{display:'flex', justifyContent:'space-between'}}>
                                 
                                 <Typography sx={StyleHome.textPrimary}>
                                      {etiquetas.InterfazClienteContactInfo.Et_tblPhoneType}:
                                 </Typography>

                                 <Typography sx={StyleHome.textSecondary}>
                                    {registro.cotDsc}
                                  </Typography>

                              </div>

                              <div  style={{display:'flex', justifyContent:'space-between'}}>
                                 
                                 <Typography sx={StyleHome.textPrimary}>
                                    {etiquetas.InterfazClienteContactInfo.Et_tblCountryCode}:
                                 </Typography>

                                 <Typography sx={StyleHome.textSecondary}>
                                    {registro.cucCountryCode}
                                  </Typography>

                              </div>

                              <div style={{display:'flex', justifyContent:'space-between'}}>
                                 
                                 <Typography sx={StyleHome.textPrimary}>
                                      {etiquetas.InterfazClienteContactInfo.Et_tblPhone}:
                                 </Typography>

                                 <Typography sx={StyleHome.textSecondary}>
                                    {registro.cucPhone}
                                  </Typography>

                              </div>

                              <div style={{display:'flex', justifyContent:'space-between'}}>
                                 
                                 <Typography sx={StyleHome.textPrimary}>
                                      {etiquetas.General.Et_tblAcciones}:
                                 </Typography>

                                 <IconButton style={styleTable.BodyButtoms}
                                    disabled={CodigoVerificado === false}
                                    onClick={() => {
                                        setRegistro({ id: registro.cucCustomerContactId, text: registro.cucPhone });
                                    }}>
                                    <DeleteIcon fontSize="normal" />
                                </IconButton>

                              </div>

                              </div>
                          )):null}
                     </div>

                    :
                        
                        
                        <TableContainer component={Grid} style={styleTable.TableConteiner}>
                            <Table stickyHeader>
                                <TableHead style={styleTable.TableHeader}>
                                    <StyledTableRowHeaderClass>
                                        <StyledTableCellClass>{etiquetas.InterfazClienteContactInfo.Et_tblPhoneType}</StyledTableCellClass>
                                        <StyledTableCellClass width='125px'>{etiquetas.InterfazClienteContactInfo.Et_tblCountryCode}</StyledTableCellClass>
                                        <StyledTableCellClass>{etiquetas.InterfazClienteContactInfo.Et_tblPhone}</StyledTableCellClass>
                                        <StyledTableCellClass width='85px' Align='center'>{etiquetas.General.Et_tblAcciones}</StyledTableCellClass>
                                    </StyledTableRowHeaderClass>
                                </TableHead>
                                <TableBody>
                                    {listContacts.length > 0 ? listContacts.map((registro) => (
                                        <StyledTableRowClass key={registro.cucCustomerContactId}>
                                            <StyledTableCellClass component="th" scope="row">{registro.cotDsc}</StyledTableCellClass>
                                            <StyledTableCellClass width='125px'>{registro.cucCountryCode}</StyledTableCellClass>
                                            <StyledTableCellClass>{registro.cucPhone}</StyledTableCellClass>
                                            <StyledTableCellClass width='85px' Align='center'>
                                                <div style={styleTable.BodyContainerButtoms}>
                                                    <Tooltip title={etiquetas.General.Et_tbnFavorito}>
                                                        <IconButton style={styleTable.BodyButtoms}
                                                            disabled={CodigoVerificado === false}
                                                            onClick={() => {
                                                                if (registro.cucFavorite === false)
                                                                    EditarContactoFavorito(registro);
                                                            }}>
                                                            {registro.cucFavorite === false ?
                                                                <StarBorderOutlinedIcon fontSize="normal" />
                                                                :
                                                                <StarIcon fontSize="normal" />
                                                            }
                                                        </IconButton>
                                                    </Tooltip>
                                                    <Tooltip title={etiquetas.General.Et_tbnEditar}>
                                                        <IconButton style={styleTable.BodyButtoms}
                                                            disabled={CodigoVerificado === false}
                                                            onClick={() => EditarContacto(registro)}>
                                                            <EditIcon fontSize="normal" />
                                                        </IconButton>
                                                    </Tooltip>
                                                    <Tooltip title={etiquetas.General.Et_tbnEliminar}>
                                                        <IconButton style={styleTable.BodyButtoms}
                                                            disabled={CodigoVerificado === false}
                                                            onClick={() => {
                                                                setRegistro({ id: registro.cucCustomerContactId, text: registro.cucPhone });
                                                            }}>
                                                            <DeleteIcon fontSize="normal" />
                                                        </IconButton>
                                                    </Tooltip>
                                                </div>
                                            </StyledTableCellClass>
                                        </StyledTableRowClass>
                                    )) : (<StyledTableRowClass>
                                        <StyledTableCellClass colSpan={4}>{etiquetas.General.Et_tblTableEmty}</StyledTableCellClass>
                                    </StyledTableRowClass>)}
                                </TableBody>
                            </Table>
                        </TableContainer> }
                    </Grid>
                </Grid>
            </div>
        </React.Fragment>
    );
};

export default TelefonosClientes;